import { defineAction } from '~/prix'
import { inventoryObject } from '../inventoryObject'
import inventoryListAction from './inventoryList.action.json' with { type: 'json' }
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'

export const inventoryExpression = expression(inventoryObject.shape)

const inventoryListDefinition = defineAction({
  ...inventoryListAction,
  input: z.object({
    filter: inventoryExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      synchronizedAt: 'Data de sincronização',
      id: 'Identificador',
      equipmentName: 'Nome do equipamento',
      serialNumber: 'Número de série',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(inventoryObject),
    count: z.number(),
  }),
})

export default inventoryListDefinition
